import {
  trigger,
  animate,
  transition,
  style,
  AnimationBuilder,
  AnimationPlayer,
} from '@angular/animations';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, Inject, OnDestroy, OnInit, Optional, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Market } from 'src/app/core/models/market.model';
import { AppService } from 'src/app/core/services/app.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'bit-new-landing',
  templateUrl: './new-landing.component.html',
  styleUrls: ['./new-landing.component.scss'],
  animations: [
    trigger('fade', [
      transition(':enter', [
        // query('')
        style({
          opacity: 0,
          position: 'absolute',
        }),
        animate('150ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({
          opacity: 1,
        }),
        animate('150ms', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class NewLandingComponent implements OnInit, OnDestroy {
  isLanguageMenuVisible = false;

  itemAnimationState = 'void'; // Initial state (hidden)

  items = [1, 2, 3, 4];
  menuToggle = false;

  isCryptoListOpen = false

  @ViewChild('anime') item!: ElementRef;

  userEmail = '';

  intervalId?: any;

  constructor(
    private title: Title,
    @Inject(PLATFORM_ID) private platformId: string,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router, @Optional()
    @Inject('lang') private lang: string,
    private _builder: AnimationBuilder,
    public appService: AppService
  ) {
    this.title.setTitle($localize`bit.ir |   ارز دیجیتال | خرید و فروش ارز دیجیتال`)
  }

  markets: Market[] = [];

  shownMarkets?: Market[];
  isFirstFour = true;

  ngOnInit(): void {
    this.setTags()
    this.handleMarkets()
  }

  handleMarkets() {
    if (!isPlatformBrowser(this.platformId)) return;
    this.appService.getMarketList('IRR').subscribe((v) => {
      if (!v.length) return;
      this.markets = v;
      this.shownMarkets = this.markets.slice(0, 4);
      this.intervalId = setInterval(() => {
        let [leave, enter, duration] = this.getAnimations();
        leave.play();
        setTimeout(() => {
          if (this.isFirstFour) {
            this.shownMarkets = this.markets.slice(4, 8);
            this.isFirstFour = false;
          } else {
            this.shownMarkets = this.markets.slice(0, 4);
            this.isFirstFour = true;
          }
          enter.play();
        }, duration);
      }, 4000);
    });
  }

  getAnimations(): [AnimationPlayer, AnimationPlayer, number] {
    const duration = 350;
    const leave = this._builder
      .build(
        animate(
          duration + 'ms ease-out',
          style({ transform: 'translateY(15px)', opacity: 0 })
        )
      )
      .create(this.item.nativeElement);
    const enter = this._builder
      .build([
        style({ transform: 'translateY(-15px)', opacity: 0 }),
        animate(
          duration + 'ms ease-in',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ])
      .create(this.item.nativeElement);

    return [leave, enter, duration];
  }

  // constructor(
  //    {
  //   this.title.setTitle($localize`bit.ir |   ارز دیجیتال | خرید و فروش ارز دیجیتال`)
  // }

  private setTags(): void {
    if (this.document) {
      const canonical = this.document.querySelector('link[rel="canonical"]');
      if (canonical) {
        if (isPlatformBrowser(this.platformId)) {
          this.renderer.setAttribute(canonical, 'href', window.location.href);
        } else {
          this.renderer.setAttribute(canonical, 'href', environment.domain + this.lang );
        }
      }
    }
  }

  ngOnDestroy(): void {
      clearInterval(this.intervalId)
  }
}
